export const Footer = () => (
  <footer
    data-testid="site-footer"
    className="border-t border-line bg-void px-6 py-10 md:px-12"
  >
    <div className="mx-auto flex max-w-[1400px] flex-col gap-4 font-mono text-[10px] tracking-[0.25em] text-slate-600 md:flex-row md:items-center md:justify-between">
      <span>
        PROJECT ECLIPSE <span className="text-signal">//</span> PROTOCOL ZERO
      </span>
      <span className="redacted">THIS PAGE DOES NOT EXIST</span>
      <span>© 2026 ECLIPSE INTERACTIVE — ALL TRANSMISSIONS MONITORED</span>
    </div>
  </footer>
);
